import { render, staticRenderFns } from "./PopOverBase.vue?vue&type=template&id=1d4a3d98&scoped=true&"
import script from "./PopOverBase.vue?vue&type=script&lang=js&"
export * from "./PopOverBase.vue?vue&type=script&lang=js&"
import style0 from "./PopOverBase.vue?vue&type=style&index=0&id=1d4a3d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4a3d98",
  null
  
)

/* custom blocks */
import block0 from "./PopOverBase.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports